import z from "zod";
import createSchemaUtils from "../../helpers/createSchemaUtils";
import { SafeNameSchema } from "../common";

export const PlainObjectSchema = z.record(SafeNameSchema, z.any());
export type PlainObject = z.infer<typeof PlainObjectSchema>;
export const PlainObject = createSchemaUtils(PlainObjectSchema);